var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row justify-content-center" }, [
    !_vm.friend_id && _vm.currentGroupChat === null
      ? _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card card-default" }, [
            _c(
              "div",
              {
                staticClass:
                  "pb-1 d-flex align-items-center border-bottom p-0 m-1 card-header",
              },
              [
                _c("div", [
                  _c("h3", { staticClass: "text-bold-700 mb-0" }, [
                    _c("i", { staticClass: "feather icon-send" }),
                    _vm._v(" " + _vm._s(_vm.__("chat.compose_new_message"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ml-auto" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn-sm btn-outline-primary",
                      attrs: { href: "/member/messages" },
                    },
                    [
                      _c("i", { staticClass: "feather icon-arrow-left" }),
                      _vm._v(
                        " " + _vm._s(_vm.__("chat.form.links.back_inbox")) + " "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "pl-2 pr-2" }, [
              !_vm.startGroupChat
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search",
                      },
                    ],
                    staticClass: "mb-05 form-control",
                    attrs: {
                      placeholder: "Search all contacts to chat",
                      type: "text",
                      autofocus: "",
                    },
                    domProps: { value: _vm.search },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.search = $event.target.value
                        },
                        _vm.debounceInput,
                      ],
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.startGroupChat
              ? _c("div", { staticClass: "row pl-2 pr-2" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchForGroup,
                          expression: "searchForGroup",
                        },
                      ],
                      staticClass: "mb-05 form-control",
                      attrs: {
                        placeholder: "Search for contacts to add to your group",
                        type: "text",
                      },
                      domProps: { value: _vm.searchForGroup },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchForGroup = $event.target.value
                          },
                          _vm.debounceInput,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _vm.selectedGroupMembers.length > 0
                      ? _c(
                          "div",
                          { staticClass: "pb-05 selected-members-list" },
                          [
                            _c(
                              "span",
                              { staticClass: "font-small-3 text-bold-700" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.__("chat.group_participants"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _vm._l(_vm.selectedGroupMembers, function (member) {
                              return _c(
                                "span",
                                {
                                  key: member.id + Math.random(),
                                  staticClass: "badge p-1 mr-05 badge-blue",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(member.first_name) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-sm btn-outline-danger text-danger",
                        on: { click: _vm.cancelGroup },
                      },
                      [_vm._v(_vm._s(_vm.__("chat.form.links.cancel_group")))]
                    ),
                    _vm._v(" "),
                    _vm.selectedGroupMembers.length > 0
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "pl-05 btn btn-sm btn-success text-white",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.createGroupSession.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.__("chat.form.links.start_group_chat")
                              ) + " "
                            ),
                            _c("i", {
                              staticClass: "feather icon-chevron-right",
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 group-chat-members card-body" },
                    [
                      this.searchForGroup !== null && _vm.friends.length > 0
                        ? _c(
                            "span",
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(_vm.__("chat.add_contact_to_group"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group" },
                                _vm._l(_vm.friends, function (friend) {
                                  return _c(
                                    "li",
                                    {
                                      key: friend.id + Math.random(),
                                      staticClass: "list-group-item",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.addToGroup(friend)
                                        },
                                      },
                                    },
                                    [
                                      _c("a", {
                                        staticStyle: { color: "#212529" },
                                        attrs: { href: "" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          _c("div", {}, [
                                            _c("img", {
                                              staticClass: "round",
                                              attrs: {
                                                src:
                                                  friend.avatar !== null
                                                    ? friend.avatar.url
                                                    : "/images/avatar.png",
                                                alt: "avatar",
                                                height: "30",
                                                width: "30",
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "ml-05" }, [
                                            _c("span", { staticClass: "h5" }, [
                                              _vm._v(
                                                "  " +
                                                  _vm._s(friend.first_name) +
                                                  " " +
                                                  _vm._s(friend.last_name)
                                              ),
                                              _vm.friendExistsInGroup(friend)
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa pl-1 text-success fa-check-circle",
                                                  })
                                                : _vm._e(),
                                            ]),
                                            _vm._v(" "),
                                            friend.session &&
                                            friend.session.unreadCount > 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        friend.session
                                                          .unreadCount
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-light text-bold-700  font-small-2 d-block",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(friend.position) +
                                                    " / " +
                                                    _vm._s(
                                                      friend.organisation
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            friend.online
                                              ? _c("i", {
                                                  staticClass:
                                                    "fas fa-circle float-right success",
                                                  staticStyle: {
                                                    position: "absolute",
                                                    top: "15px",
                                                    right: "15px",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "infinite-loading",
                                {
                                  attrs: { identifier: _vm.infiniteId },
                                  on: {
                                    distance: function ($event) {
                                      1
                                    },
                                    infinite: _vm.infiniteHandler,
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "text-light",
                                    attrs: { slot: "no-more" },
                                    slot: "no-more",
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    attrs: { slot: "no-results" },
                                    slot: "no-results",
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.startGroupChat
              ? _c("div", { staticClass: "card-body" }, [
                  _c("h3", { attrs: { id: "search_heading" } }, [
                    _vm._v(_vm._s(_vm.__("chat.your_contacts"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-group" },
                    [
                      _vm._l(_vm.friends, function (friend) {
                        return _c(
                          "span",
                          { key: "friend" + friend.id + Math.random() },
                          [
                            friend.contact === 1 ||
                            (_vm.search !== null && _vm.search !== "")
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "list-group-item",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openChat(friend)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-between",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c("div", {}, [
                                              _c("img", {
                                                staticClass: "round",
                                                attrs: {
                                                  src:
                                                    friend.avatar !== null
                                                      ? friend.avatar.url
                                                      : "/images/avatar.png",
                                                  alt: "avatar",
                                                  height: "30",
                                                  width: "30",
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "ml-05" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "h5" },
                                                  [
                                                    _vm._v(
                                                      "  " +
                                                        _vm._s(
                                                          friend.first_name
                                                        ) +
                                                        " " +
                                                        _vm._s(friend.last_name)
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                friend.session &&
                                                friend.session.unreadCount > 0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "badge badge-pill badge-primary badge-sm",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            friend.session
                                                              .unreadCount
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-light font-small-2 d-block",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          friend.position
                                                        ) +
                                                        " | " +
                                                        _vm._s(
                                                          friend.organisation
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                friend.online
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fas fa-circle float-right success",
                                                      staticStyle: {
                                                        position: "absolute",
                                                        top: "15px",
                                                        right: "15px",
                                                        width: "15px",
                                                        height: "15px",
                                                        "background-color":
                                                          "green",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(0, true),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      this.search
                        ? _c(
                            "infinite-loading",
                            {
                              attrs: { identifier: _vm.infiniteId },
                              on: {
                                distance: function ($event) {
                                  1
                                },
                                infinite: _vm.infiniteHandler,
                              },
                            },
                            [
                              _c("div", {
                                staticClass: "text-light",
                                attrs: { slot: "no-more" },
                                slot: "no-more",
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  attrs: { slot: "no-results" },
                                  slot: "no-results",
                                },
                                [_vm._v("No results")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.currentGroupChat === null
      ? _c(
          "div",
          { staticClass: "col-md-8" },
          _vm._l(_vm.friends, function (friend) {
            return friend.session
              ? _c(
                  "span",
                  { key: friend.id + Math.random() },
                  [
                    friend.session.open
                      ? _c("message", {
                          attrs: { friend: friend },
                          on: {
                            close: function ($event) {
                              return _vm.close(friend)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e()
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.currentGroupChat != null
      ? _c(
          "div",
          { staticClass: "col-md-8" },
          _vm._l(_vm.groupSessions, function (groupSession) {
            return _c(
              "span",
              { key: groupSession.id + Math.random() },
              [
                _vm.currentGroupChat.id === groupSession.id
                  ? _c("group-message", {
                      attrs: { "group-session": groupSession },
                      on: {
                        close: function ($event) {
                          return _vm.closeGroupChat(groupSession)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.chatAvailable
      ? _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card card-default" }, [
            _c(
              "div",
              {
                staticClass:
                  "pb-1 d-flex align-items-center border-bottom p-0 m-1 card-header",
              },
              [
                _c("div", { staticClass: "ml-auto" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn-sm btn-outline-primary",
                      attrs: { href: "/member/messages" },
                    },
                    [
                      _c("i", { staticClass: "feather icon-arrow-left" }),
                      _vm._v(
                        " " + _vm._s(_vm.__("chat.form.links.back_inbox")) + " "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm._m(1),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "feather icon-chevron-right h3" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c(
        "div",
        {
          staticClass: "alert alert-primary alert-important",
          attrs: {
            role: "alert",
            "aria-live": "polite",
            "aria-atomic": "true",
          },
        },
        [
          _c("div", { staticClass: "alert-body" }, [
            _c("span", [_vm._v("This chat is not available.")]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }